export const PATIENTS_TESTID_PREFIX = 'patients-page';

export const testIdSlug = (value?: string | number | null): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const patientsTestId = (...parts: Array<string | number | null | undefined>): string =>
  [PATIENTS_TESTID_PREFIX, ...parts.map(testIdSlug)].filter(Boolean).join('-');

export const patientsRowTestId = (
  base: string,
  identity: string | number | null | undefined,
  suffix?: string
): string | undefined =>
  testIdSlug(identity) ? patientsTestId(base, identity, suffix) : undefined;

export const patientsOptionTestId = (
  selectTestId: string | undefined,
  value: string | number | null | undefined
): string | undefined =>
  selectTestId && testIdSlug(value) ? `${selectTestId}-option-${testIdSlug(value)}` : undefined;

export const patientFormTestId = (field: string) => patientsTestId('patient-form', field);

export const payerFormTestId = (field: string) => patientsTestId('payer-form', field);
